import { useDispatch, useSelector } from "react-redux";
import {
  fetchOffersProduct,
  changeStateTrue,
  changeStateFalse,
  changeLoading,
  fetchOfferFilters,
  clearProduct,
} from "../features/productSlice";
import { useState, useEffect, useCallback, useRef } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import META from "../common/meta";
import ProductCard from "../components/product/product";
import CatlogPriceFilter from "../components/priceSlider/price-slider";
import { Container, Row, Col, Dropdown, Form } from "react-bootstrap";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../static/css/App.css";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
library.add(fas, fab, far);
function Offers() {
  const { slug } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [priceFilter, setPriceFilter] = useState(null);
  const [brandFilter, setBrandFilter] = useState([]);
  const [brandIdFilter, setBrandIdFilter] = useState([]);
  const [categoryFilter, setCategoryFilter] = useState([]);
  const [sorting, setSorting] = useState(null);
  const [order, setOrder] = useState(null);
  const [hasLoaded, setHasLoaded] = useState(false);
  const LIMIT = 20;                 // whatever your API default page size is
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const seenIds = useRef(new Set());
  const sentinelRef = useRef(null);
  //                const[categoryId, setCategoryId] = useState(null);
  const dispatch = useDispatch();
  const {
    productList,
    error,
    response,
    completed,
    filterCategories,
    filterBrands,
    minPrice,
    maxPrice,
  } = useSelector((state) => state.product);
  const inFlight = useRef(false);
  const endedRef = useRef(false);
  const obsRef = useRef(null);
  const requestedSigRef = useRef(new Set());
  const fetchData = useCallback((overrideOffset) => {
    if (inFlight.current || endedRef.current || !hasMore) return;

    const curOffset =
      overrideOffset !== undefined ? overrideOffset : offset;

    // Build a *unique* request signature: filters + sort + offset (+ branch if needed)
    const sig = JSON.stringify({
      brandId: brandIdFilter.slice().sort(), // normalize order
      brand: brandFilter.slice().sort(),
      category: categoryFilter.slice().sort(),
      order,
      sorting,
      price: priceFilter ?? null,
      offset: curOffset,
      limit: LIMIT,
    });

    // If we already asked for this exact page, bail out
    if (requestedSigRef.current.has(sig)) return;
    requestedSigRef.current.add(sig);

    inFlight.current = true;
    setIsLoading(true);

    return dispatch(
      fetchOffersProduct({
        categoryId: categoryFilter.join(","),
        price: priceFilter,
        brand: brandFilter.join(","),
        brandId: brandIdFilter.join(","),
        order,
        sort: sorting,
        offset: curOffset,
        limit: LIMIT,
      })
    )
      .unwrap()
      .then((res) => {
        // API: { status: "SUCCESS" | "FAIL", message, data: [...] }
        // Some responses may be HTTP 304 with no body; defensively handle that:
        const ok = res?.status === "SUCCESS";
        const items = ok && Array.isArray(res?.data) ? res.data : [];
        const count = items.length;

        // advance cursor only on success
        if (ok) setOffset((prev) => prev + count);

        // stop on FAIL or short page (incl. 0)
        const reachedEnd = !ok || count < LIMIT;
        if (reachedEnd) {
          endedRef.current = true;          // hard stop (synchronous)
          setHasMore(false);
          if (obsRef.current) {
            obsRef.current.disconnect();    // detach the observer so it cannot fire again
            obsRef.current = null;
          }
        }

        console.log({
          ok,
          count,
          prevOffset: curOffset,
          nextOffset: ok ? curOffset + count : curOffset,
          reachedEnd,
        });
      })
      .catch((err) => {
        // On error, also stop further calls (prevents retry storms)
        endedRef.current = true;
        setHasMore(false);
        if (obsRef.current) {
          obsRef.current.disconnect();
          obsRef.current = null;
        }
        console.error("fetchOffersProduct failed:", err);
      })
      .finally(() => {
        inFlight.current = false;
        setIsLoading(false);
        setHasLoaded(true);
      });
  }, [
    dispatch,
    categoryFilter, priceFilter, brandFilter, brandIdFilter,
    order, sorting, offset, hasMore
  ]);





  useEffect(() => {
    dispatch(changeLoading());
    if (searchParams.size > 0) {
      const b = searchParams.get("brand");
      const c = searchParams.get("category");
      if (b) {
        dispatch(fetchOfferFilters({ brand: b }));
        setBrandFilter([b]);
      }
      if (c) {
        dispatch(fetchOfferFilters({ categoryId: c }));
        setCategoryFilter([c]);
      }
    } else {
      dispatch(fetchOfferFilters({
        brand: brandFilter.join(","),
        categoryId: categoryFilter.join(","),
      }));
      fetchData();
    }
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const node = sentinelRef.current;
    if (!node || !hasMore) return;

    const obs = new IntersectionObserver(
      (entries) => {
        const first = entries[0];
        if (!first.isIntersecting) return;
        if (isLoading || inFlight.current || endedRef.current) return;
        fetchData();
      },
      { root: null, rootMargin: "0px", threshold: 1.0 }
    );

    obs.observe(node);
    obsRef.current = obs;

    return () => {
      obs.disconnect();
      if (obsRef.current === obs) obsRef.current = null;
    };
  }, [fetchData, hasMore, isLoading]);


  useEffect(() => {
    if (priceFilter !== null) {
      dispatch(clearProduct());
      setOffset(0);
      setHasMore(true);
      endedRef.current = false;
      requestedSigRef.current.clear();
      seenIds.current = new Set();
      fetchData(0);
    }
  }, [priceFilter, dispatch]);

  useEffect(() => {
    if (brandFilter.length > 0) {
      dispatch(clearProduct());
      setOffset(0);
      setHasMore(true);
      endedRef.current = false;
      requestedSigRef.current.clear();
      seenIds.current = new Set();
      fetchData(0);
    }
  }, [brandFilter, dispatch]);

  useEffect(() => {
    if (brandIdFilter.length > 0) {
      dispatch(clearProduct());
      setOffset(0);
      setHasMore(true);
      endedRef.current = false;
      requestedSigRef.current.clear();
      seenIds.current = new Set();
      fetchData(0);
    }
  }, [brandIdFilter, dispatch]);

  useEffect(() => {
    if (categoryFilter.length > 0) {
      dispatch(clearProduct());
      setOffset(0);
      setHasMore(true);
      endedRef.current = false;
      seenIds.current = new Set();
      fetchData(0);
    }
  }, [categoryFilter, dispatch]);

  useEffect(() => {
    if (order) {
      dispatch(clearProduct());
      setOffset(0);
      setHasMore(true);
      endedRef.current = false;
      requestedSigRef.current.clear();
      seenIds.current = new Set();
      fetchData(0);
    }
  }, [order, dispatch]);


  const handleBrandFilter = (e) => {
    let brandId = e.target.value;
    if (brandIdFilter.indexOf(brandId) >= 0) {
      setBrandIdFilter(brandIdFilter.filter((bf) => bf !== brandId));
    } else {
      setBrandIdFilter([...brandIdFilter, brandId]);
    }
  };
  const handleCategoryFilter = (e) => {
    let brandId = e.target.value;
    if (brandId == "all") {
      dispatch(
        fetchOfferFilters({ brand: brandFilter.join(","), categoryId: null })
      );
    }
    //        if (categoryFilter.indexOf(brandId) >= 0) {
    //            setCategoryFilter(categoryFilter.filter((bf) => bf !== brandId));
    //        } else {
    setCategoryFilter([brandId]);
    //        }
  };
  const handleSortingFilter = (e) => {
    let value = e.target.value;
    setSorting("price");
    if (value == 1) {
      setOrder("low");
    } else if (value == 2) {
      setOrder("high");
    } else if (value == 4) {
      setSorting("name");
      setOrder("asc");
    } else if (value == 5) {
      setSorting("name");
      setOrder("desc");
    } else {
      setOrder("default");
    }
  };

  const handleResetFilters = () => {
    setPriceFilter(null);
    setBrandFilter([]);
    setBrandIdFilter([]);
    setCategoryFilter([]);
    setSorting(null);
    setOrder(null);
    dispatch(clearProduct());
    dispatch(fetchOfferFilters({ brand: "", categoryId: "" }));
    setOffset(0);
    setHasMore(true);
    seenIds.current = new Set();
    fetchData(0);
  };
  // useEffect(() => {
  //   if (order) {
  //     dispatch(clearProduct());
  //     fetchData();
  //   }
  // }, [order]);
  return (
    <div>
      <Container fluid="xl" className="px-md-5 px-3 px-xl-3">
        <Row className="my-4">
          <Col md="3">
            <h1 className="fs-4">Offers</h1>
          </Col>
          <Col md="4">
            <label className="float-start" style={{ paddingLeft: "5%" }}>
              Price Range
            </label>
            {minPrice && maxPrice && (
              <CatlogPriceFilter
                min={minPrice}
                max={maxPrice}
                setPriceFilter={setPriceFilter}
              />
            )}
          </Col>
          <Col md="5" className="text-end">
            <Dropdown className="d-inline mx-2" autoClose="outside">
              <Dropdown.Toggle
                className="product-filters text-white"
                id="dropdown-autoclose-outside"
              >
                Brands
              </Dropdown.Toggle>

              <Dropdown.Menu className="filter-brand-section">
                {filterBrands &&
                  filterBrands.length > 0 &&
                  filterBrands.map((fb, index) => (
                    <Dropdown.Item as="button" key={index}>
                      <Form.Check
                        type="checkbox"
                        id={`brand-checkbox-${index}`}
                        label={fb.brandName}
                        value={fb.brandID}
                        name="brand"
                        onChange={handleBrandFilter}
                      />
                    </Dropdown.Item>
                  ))}
              </Dropdown.Menu>
            </Dropdown>
            <Dropdown className="d-inline mx-2" autoClose="outside">
              <Dropdown.Toggle
                className="product-filters text-white"
                id="dropdown-autoclose-outside"
              >
                Categories
              </Dropdown.Toggle>

              <Dropdown.Menu className="filter-category-section">
                <Dropdown.Item as="button" key="0">
                  <Form.Check
                    type="radio"
                    id="category-checkbox"
                    label="All"
                    value="all"
                    name="category"
                    onChange={handleCategoryFilter}
                  />
                </Dropdown.Item>
                {filterCategories &&
                  filterCategories.length > 0 &&
                  filterCategories.map((fb, index) => (
                    <Dropdown.Item as="button" key={index}>
                      <Form.Check
                        type="radio"
                        id={`category-checkbox-${index}`}
                        label={fb.categoryName}
                        value={fb.slug}
                        name="category"
                        onChange={handleCategoryFilter}
                      />
                    </Dropdown.Item>
                  ))}
              </Dropdown.Menu>
            </Dropdown>

            <Dropdown className="d-inline mx-2" autoClose="true">
              <Dropdown.Toggle
                className="product-filters  text-white"
                id="dropdown-autoclose-inside"
              >
                Default Sorting
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item as="button" key="sort-0">
                  <Form.Check
                    type="radio"
                    id="sorting-checkbox-0"
                    label="Default Sorting"
                    value="0"
                    name="sorting"
                    onChange={handleSortingFilter}
                  />
                </Dropdown.Item>
                <Dropdown.Item as="button" key="sort-1">
                  <Form.Check
                    type="radio"
                    id="sorting-checkbox-1"
                    label="Price Low"
                    value="1"
                    name="sorting"
                    onChange={handleSortingFilter}
                  />
                </Dropdown.Item>
                <Dropdown.Item as="button" key="sort-2">
                  <Form.Check
                    type="radio"
                    id="sorting-checkbox-2"
                    label="Price High"
                    value="2"
                    name="sorting"
                    onChange={handleSortingFilter}
                  />
                </Dropdown.Item>
                <Dropdown.Item as="button" key="sort-4">
                  <Form.Check
                    type="radio"
                    id="sorting-checkbox-4"
                    label="Name Asc"
                    value="4"
                    name="sorting"
                    onChange={handleSortingFilter}
                  />
                </Dropdown.Item>
                <Dropdown.Item as="button" key="sort-5">
                  <Form.Check
                    type="radio"
                    id="sorting-checkbox-5"
                    label="Name Desc"
                    value="5"
                    name="sorting"
                    onChange={handleSortingFilter}
                  />
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
      </Container>

      <Container fluid="xl" className="px-md-5 px-3 px-xl-3">
        <Row className="my-5">

          {!isLoading && hasLoaded && (!productList || productList.length === 0) && (
            <Col xs={12} className="text-center py-5">
              <p className="mb-3 fs-5">No offer products found.</p>
              <button
                type="button"
                className="btn btn-outline-primary text-white"
                onClick={handleResetFilters}
              >
                Clear filters &amp; retry
              </button>
            </Col>
          )}

          {productList && productList.length > 0 && (
            <>
              {productList.map((product, index) =>
                product.variations.length > 0 ? (
                  <ProductCard
                    product={product}
                    key={product.productItemId || product.id || product.slug || index}
                    index={index}
                  />
                ) : null
              )}

              {/* Loading-more indicator sits under the list */}
              {isLoading && (
                <Col xs={12} className="text-center py-4">
                  <span className="fw-semibold">Loading more…</span>
                </Col>
              )}
            </>
          )}


          {/* Initial loading (before we have any items) */}
          {isLoading && !hasLoaded && (
            <Col xs={12} className="text-center py-5">
              <span className="fw-semibold">Loading offers…</span>
            </Col>
          )}
          <div ref={sentinelRef} style={{ height: 1 }} />
        </Row>
      </Container>
    </div>
  );
}

export default Offers;